import { VerticalLayout } from "ds_legacy/materials/layouts";
import { padding } from "ds_legacy/materials/metrics";
import {
  DatePickerWithLabel,
  Footnote,
  FootnoteDescription,
  FootnoteLabel,
  GAP,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { FormWatcher } from "react-forms-state/src";
import { useTranslations } from "translations";
import Translations from "translations/types";

const FOOTNOTES: Record<"one" | "two", Footnote> = {
  one: {
    description: (translations: Translations) =>
      translations.patientForms.transitionalCareForm.hospitalStay.footnoteOne,
    label: (translations: Translations) =>
      translations.patientForms.transitionalCareForm.hospitalStay.locationId,
    superText: 1,
  },
  two: {
    description: (translations: Translations) =>
      translations.patientForms.transitionalCareForm.hospitalStay.footnoteTwo,
    label: (translations: Translations) =>
      translations.patientForms.transitionalCareForm.hospitalStay
        .departmentCode,
    superText: 2,
  },
};

export const TransitionalCareSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.hospitalStay
          .titleTransitionalCare
      }
    >
      <SectionRow>
        <DatePickerWithLabel
          elementName="transitional_care_start_date"
          isBold
          label={
            translations.patientForms.transitionalCareForm.hospitalStay
              .startDateTransitionalCare
          }
        />
        <FormWatcher watchPath="transitional_care_start_date">
          {({ watchedValue }) => {
            return (
              <DatePickerWithLabel
                blockBefore={watchedValue}
                elementName="transitional_care_end_date"
                isBold
                label={
                  translations.patientForms.transitionalCareForm.hospitalStay
                    .endDateTransitionalCare
                }
              />
            );
          }}
        </FormWatcher>
        <TextInputWithLabel
          elementName="transitional_care_location_id"
          isBold
          isLarge
          label={<FootnoteLabel footnote={FOOTNOTES.one} />}
        />
        <TextInputWithLabel
          elementName="transitional_care_department_code"
          isBold
          label={<FootnoteLabel footnote={FOOTNOTES.two} />}
        />
      </SectionRow>
      <VerticalLayout
        style={{
          boxSizing: "border-box",
          padding: padding(GAP, 0, 0),
        }}
      >
        <FootnoteDescription footnote={FOOTNOTES.one} />
        <FootnoteDescription footnote={FOOTNOTES.two} />
      </VerticalLayout>
    </Section>
  );
};
